import { IApiResponse } from "../../Orchestrator/Types/Index";
import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { ITicketOptionResponse } from "../../Orchestrator/Types/Interface/ITicketOption";

export async function getMetaTicketOptions(showLoader: boolean = true): Promise<IApiResponse<ITicketOptionResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.getTicketOptions;
    return await apiRequest<ITicketOptionResponse>(endpoint, 'GET', {}, "none", undefined, undefined, showLoader);
}
